import axios from 'axios'
import { apiUrl } from '../config'
import authenticationStore from '../stores/authenticationStore'

export const ScanPdfRequest = {
  recognizeText: file => {
    const formData = new FormData()
    formData.append('file', file)

    return axios({
      method: 'post',
      url: `${apiUrl}/api/v1/ocr`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'multipart/form-data',
      },
      data: formData,
    })
  },

  getOcrStatus: () => {
    return axios({
      method: 'get',
      url: `${apiUrl}/api/v1/ocr/status`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
    })
  },
}
